import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import ImpressionSearch from './ImpressionSearch'
import { findingSettingUpdate } from '../../../../../redux/actions/settingActions/findingSettingActions'
import { dataLoad } from '../../../../../redux/actions/autoCompleteActions'
import { examFindingInfo, examSelectedFinding } from '../../../../../redux/actions/exam/examFindingActions'

function SettingImpression(props) {
  // Setting Impressions want to Associated with Finding
  const { selectedFinding, wrapperClasses, staffId } = props
  const dispatch = useDispatch()
  const [selectedIds, setSelectedIds] = useState(selectedFinding?.impressions_attributes ?? [])
  const defaultFilters = { klass: 'Settings::Impression', rpp: 10, filter: { staff_id: staffId } }

  const handleImpressions = (impression_ids) => {
    setSelectedIds(impression_ids)
  }

  const handleAddToFinding = async () => {
    let finding = await dispatch(findingSettingUpdate({ ...selectedFinding, staff_id: staffId, impression_ids: selectedIds }, { include: '*' }))
    finding = finding.value.data.finding
    dispatch(examSelectedFinding(finding))
    dispatch(examFindingInfo({ dropdownType: 'finding_impression' }))
  }

  const handleSettingImpressionsLoad = async (filters) => {
    let res = await dispatch(dataLoad({ ...defaultFilters, ...filters }))
    res = res.value.data.data
    return res
  }

  const handleAddFromMapped = () => {
    dispatch(examFindingInfo({ dropdownType: 'finding_impression' }))
  }

  return (
    <div className={`${wrapperClasses}`}>
      <h6 className='pb-4'>Associated Diagnosis</h6>
      <div className='d-flex justify-content-end flex-wrap'>
        <button type="button" className={`btn btn-sm btn-outline-primary font-size-12 px-3 mb-4 ${!selectedFinding?.impressions_attributes?.length && 'disabled'}`} onClick={handleAddFromMapped} disabled={!selectedFinding?.impressions_attributes?.length}>
          <i className="las la-angle-left mr-1"></i>Mapped Dx
        </button>
        <button type="button" className={`btn btn-sm btn-primary ml-4 font-size-12 px-3 mb-4 ${!selectedIds.length && 'disabled'}`} onClick={handleAddToFinding} disabled={!selectedIds.length}>
          <i className="las la-plus mr-1"></i>Add To Finding
        </button>
      </div>
      <ImpressionSearch
        textField='name'
        valueField='id'
        defaultValues={selectedFinding.impressions_attributes?.map(item => item.id) ?? []}
        onSelectHook={impression_ids => handleImpressions(impression_ids)}
        wrapperClasses="mb-5"
        autoCompleteLoad={handleSettingImpressionsLoad}
      />
    </div>
  )
}

const mapStateToProps = state => {
  const { examFinding, exam } = state

  return {
    selectedFinding: examFinding.selectedFinding,
    staffId: exam.exam.staff_id,
  }
}

export default connect(mapStateToProps)(SettingImpression)